var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("activities-calendar", {
    staticClass: "calendar",
    attrs: {
      "get-activities-by-date": _vm.getActivitiesByDate("Camp"),
      "get-activities-by-date-and-time": _vm.getActivitiesByDateAndTime("Camp"),
      "activity-type": "Camp",
      mode: _vm.mode,
      "calendar-date": _vm.calendarDate,
      "date-format": _vm.dateFormat
    },
    on: {
      "change-date": _vm.changeActivityCalendarDate,
      "change-mode": _vm.changeActivityCalendarMode,
      "fetch-activities": function() {
        return _vm.getActivitiesCalendar({
          activityType: "Camp",
          schoolId: _vm.schoolId
        })
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a23973d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a23973d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camps/CampCalendar.vue
// module id = null
// module chunks = 